<fdx-common-core>
    <div id="container" class="full">
        <div class="fx-grid fx-cf" *ngIf="!isAuthenticated">
            <div class="main-container">
                <div class="fx-col">
                    <div class="par parsys">
                        <div class="loginV3 section">
                            <div class="login-container">
                                <div class="login-class"></div>
                                <div id="fx-login" #fxLogin class="fdx-loginv3-box">
                                    <div class="leftlogin">
                                        <h2 class="title-hide">Explore our brand.</h2>
                                        <h2 class="hidden-xs">
                                            FedEx Supply Chain Customer Portal
                                        </h2>
                                        <!-- <p id="demo">Access logos, photos, and other brand resources to
                                        support and inspire your projects.</p>-->
                                    </div>
                                    <div id="fx-newlogin" class="new-login-box">
                                        <h2 class="hidden-brandredesign" style="display: none">
                                            FedEx Brand Resource Center
                                        </h2>
                                        <span>
                                            <p class="logintext">LOG IN: SELECT USER TYPE</p>
                                        </span>

                                        <div class="ldaplogin">
                                            <button type="button" class="ldapuser" (click)="login('I')">
                                                FedEx LDAP User
                                                <svg id="loginarrow" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                    viewBox="0 0 60 60" style="enable-background: new 0 0 60 60;"
                                                    xml:space="preserve">
                                                    <rect style="fill:none;" width="60" height="60"></rect>
                                                    <path
                                                        d="M18.4,40.5c0,2.3,0,3.4,0,5.7c0,1.7,2,2.3,3.2,1.3C28,42.1,34.5,36.7,41,31.3c0.5-0.4,0.6-0.9,0.6-1.3s-0.1-0.9-0.6-1.3
                                                    c-6.5-5.4-13-10.8-19.4-16.2c-1.2-1-3.2-0.4-3.2,1.3c0,2.3,0,3.3,0,5.6V40.5z">
                                                    </path>
                                                </svg>
                                                <p class="logintextError" *ngIf="internalUserInactive">
                                                    No customer have been assigned to your account yet
                                                </p>
                                                <p class="logintextError" *ngIf="pendingApproval">
                                                    User Approval is Pending
                                                </p>
                                                <p class="logintextError" *ngIf="serviceError">
                                                    {{serviceError}}
                                                </p>
                                            </button>
                                            <div id="ld" class="collapse">
                                                <div id="error-msg p1">
                                                    <p class="ng-binding"></p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="loginotheruser" id="loginOtherUser" #loginOtherUser>
                                            <button type="button" class="otheruserlogin" id="ou" data-toggle="collapse"
                                                data-target="#lo" (click)="redirectUser()">
                                                Customer/Vendor
                                                <svg id="loginarrow1" #loginarrow1 version="1.1"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                    viewBox="0 0 60 60" style="enable-background: new 0 0 60 60;"
                                                    xml:space="preserve">
                                                    <rect style="fill:none;" width="60" height="60"></rect>
                                                    <path
                                                        d="M18.4,40.5c0,2.3,0,3.4,0,5.7c0,1.7,2,2.3,3.2,1.3C28,42.1,34.5,36.7,41,31.3c0.5-0.4,0.6-0.9,0.6-1.3s-0.1-0.9-0.6-1.3
                                                    c-6.5-5.4-13-10.8-19.4-16.2c-1.2-1-3.2-0.4-3.2,1.3c0,2.3,0,3.3,0,5.6V40.5z">
                                                    </path>
                                                </svg>
                                            </button>
                                            <div *ngIf="spinnerValue === true" class="fdx-c-loading-indicator m-auto d-block">
                                                <div class="fdx-c-loading-indicator__part"></div>
                                                <div class="fdx-c-loading-indicator__part"></div>
                                                <div class="fdx-c-loading-indicator__part"></div>
                                                <div class="fdx-c-loading-indicator__part"></div>
                                            </div>
                                            <span class="text-danger ml-2" *ngIf="userManagementError != undefined && userManagementError != ''">
                                                {{ userManagementError }}
                                            </span>
                                        </div>

                                        <!-- NFR B-2902847 | Suppress Temp User Login Link
                                        <div class="ldaplogin mt-3">
                                            <button type="button" class="ldapuser" (click)="login('T')">
                                                Temp/Transient Users
                                                <svg id="loginarrow" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                    viewBox="0 0 60 60" style="enable-background: new 0 0 60 60;"
                                                    xml:space="preserve">
                                                    <rect style="fill:none;" width="60" height="60"></rect>
                                                    <path
                                                        d="M18.4,40.5c0,2.3,0,3.4,0,5.7c0,1.7,2,2.3,3.2,1.3C28,42.1,34.5,36.7,41,31.3c0.5-0.4,0.6-0.9,0.6-1.3s-0.1-0.9-0.6-1.3
                                                        c-6.5-5.4-13-10.8-19.4-16.2c-1.2-1-3.2-0.4-3.2,1.3c0,2.3,0,3.3,0,5.6V40.5z">
                                                    </path>
                                                </svg>
                                                <p class="logintextError" *ngIf="internalUserInactive">
                                                    No customer have been assigned to your account yet
                                                </p>
                                                <p class="logintextError" *ngIf="pendingApproval">
                                                    User Approval is Pending
                                                </p>
                                                <p class="logintextError" *ngIf="serviceError">
                                                    {{serviceError}}
                                                </p>
                                            </button>
                                            <div id="ld" class="collapse">
                                                <div id="error-msg p1">
                                                    <p class="ng-binding"></p>
                                                </div>
                                            </div>
                                        </div> -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="app-splash-screen" *ngIf="isAuthenticated === true">
            <div class="app-splash-inner">
                <div class="app-loader"></div>
            </div>
        </div>
    </div>
</fdx-common-core>

<div id="sign-in-widget"></div>
